import logo from "../logo.svg";
import "../App.css";

function Projects() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Projects
        </p>

      </header>
    </div>
  );
}

export default Projects;